/**
 * Custom Filter Drawer Enhancements (Facets System)
 * - Search within filter groups (Artist, Vinyl Colors, etc.)
 * - Truncation with Show more/less for long lists
 * - Active filter count badge on Filter Products button
 */
(function () {
  'use strict';

  var TRUNCATE_THRESHOLD = 10;
  var SEARCHABLE_MIN_ITEMS = 8;
  var initialized = false;

  function init() {
    var drawer = document.querySelector('.drawer.drawer--left');
    if (!drawer) return;

    var groups = drawer.querySelectorAll('.facets__details, .accordion-toggle');
    if (groups.length === 0) return;

    groups.forEach(function (group) {
      var list = group.querySelector('.facets__list');
      if (!list) return;

      var items = Array.from(list.querySelectorAll('.facets__item'));
      if (items.length === 0) return;

      // Search input for groups with many items
      if (items.length >= SEARCHABLE_MIN_ITEMS && !group.querySelector('.filter-search-wrap')) {
        addSearchInput(group, list, items);
      }

      // Truncation for groups with many items
      if (items.length > TRUNCATE_THRESHOLD && !group.querySelector('.filter-show-toggle')) {
        addTruncation(group, list, items);
      }
    });

    initialized = true;
  }

  function addSearchInput(group, list, items) {
    var labelEl = group.querySelector('.summary__title-name, .filter-group-label');
    var label = labelEl ? labelEl.textContent.trim().toLowerCase() : 'options';

    var wrap = document.createElement('div');
    wrap.className = 'filter-search-wrap';

    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'filter-search-input';
    input.placeholder = 'Search ' + label + '...';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');

    var noResults = document.createElement('div');
    noResults.className = 'filter-no-results';
    noResults.textContent = 'No matches found';

    wrap.appendChild(input);

    var panel = list.closest('.accordion__panel, .filter-group-display');
    if (!panel) panel = list.parentNode;

    panel.insertBefore(wrap, list);
    panel.insertBefore(noResults, list.nextSibling);

    // Prevent form submission on enter
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });

    input.addEventListener('input', function () {
      var query = this.value.toLowerCase().trim();
      var visibleCount = 0;

      var toggle = group.querySelector('.filter-show-toggle');
      if (toggle) toggle.style.display = query ? 'none' : '';

      items.forEach(function (item) {
        var text = item.textContent.toLowerCase();
        if (!query || text.indexOf(query) !== -1) {
          item.style.display = '';
          item.classList.remove('filter-search-hidden');
          // Also remove truncation hiding when searching
          if (query) item.classList.remove('filter-hidden');
          visibleCount++;
        } else {
          item.style.display = 'none';
          item.classList.add('filter-search-hidden');
        }
      });

      noResults.style.display = visibleCount === 0 ? 'block' : 'none';
    });
  }

  function addTruncation(group, list, items) {
    var visibleItems = items.filter(function (item) {
      return getComputedStyle(item).display !== 'none';
    });

    if (visibleItems.length <= TRUNCATE_THRESHOLD) return;

    for (var i = TRUNCATE_THRESHOLD; i < visibleItems.length; i++) {
      visibleItems[i].classList.add('filter-hidden');
    }

    var remaining = visibleItems.length - TRUNCATE_THRESHOLD;
    var toggle = document.createElement('button');
    toggle.className = 'filter-show-toggle';
    toggle.textContent = 'Show ' + remaining + ' more';
    toggle.setAttribute('type', 'button');

    var expanded = false;

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      expanded = !expanded;
      for (var i = TRUNCATE_THRESHOLD; i < visibleItems.length; i++) {
        if (expanded) {
          visibleItems[i].classList.remove('filter-hidden');
        } else {
          visibleItems[i].classList.add('filter-hidden');
        }
      }
      toggle.textContent = expanded ? 'Show less' : 'Show ' + remaining + ' more';
    });

    var panel = list.closest('.accordion__panel, .filter-group-display');
    if (!panel) panel = list.parentNode;
    panel.insertBefore(toggle, list.nextSibling);
  }

  /** Active filter count badge on Filter Products button */
  function initBadge() {
    var filterBtn = document.querySelector('.facets__button, [data-modal-toggle]');
    if (!filterBtn) return;

    function updateBadge() {
      var params = new URLSearchParams(window.location.search);
      var count = 0;
      params.forEach(function (val, key) {
        if (key.startsWith('filter.')) count++;
      });

      var badge = filterBtn.querySelector('.filter-count-badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'filter-count-badge';
          filterBtn.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    }

    updateBadge();
    window.addEventListener('popstate', updateBadge);
  }

  // Wait for drawer to open before initializing
  function waitForDrawer() {
    var observer = new MutationObserver(function () {
      var drawer = document.querySelector('.drawer.drawer--left');
      if (drawer && !initialized) {
        // Small delay to let drawer content render
        setTimeout(init, 150);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  // Try init immediately (drawer might already be in DOM)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initBadge();
      if (!initialized) waitForDrawer();
    });
  } else {
    init();
    initBadge();
    if (!initialized) waitForDrawer();
  }
})();

